// The positions enemies may aim at: living cities + living bases. Falls back to
// all city positions if everything is dead (so re-targeting never has 0 options).

import type { GameState, Vec2 } from './types';

export function aliveTargets(state: GameState): Vec2[] {
  const targets: Vec2[] = [];
  for (const c of state.cities) if (c.alive) targets.push(c.pos);
  for (const b of state.bases) if (b.alive) targets.push(b.pos);
  return targets.length > 0 ? targets : state.cities.map((c) => c.pos);
}
